import { API_ENV_URLS, API_ERROR_MESSAGES } from "../constants/api";

function buildConfiguredApiUrl(path, baseUrl, missingConfigMessage) {
  if (!baseUrl) {
    throw new Error(missingConfigMessage);
  }

  const normalizedBackendUrl = baseUrl.replace(/\/+$/, "");
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;

  return `${normalizedBackendUrl}${normalizedPath}`;
}

export function buildApiUrl(path) {
  return buildConfiguredApiUrl(
    path,
    API_ENV_URLS.backend,
    API_ERROR_MESSAGES.backendUrlNotConfigured,
  );
}

export function buildNebulaApiUrl(path) {
  return buildConfiguredApiUrl(
    path,
    API_ENV_URLS.nebula,
    API_ERROR_MESSAGES.nebulaUrlNotConfigured,
  );
}
